module.exports = __webpack_public_path__ + "img/Logo.b099b9c5.svg";